// extracted by mini-css-extract-plugin
export var alt = "SuccessModal-module--alt--43f49";
export var container = "SuccessModal-module--container--8aefb";
export var desktopOnly = "SuccessModal-module--desktopOnly--32698";
export var main = "SuccessModal-module--main--49ddd";
export var mobileOnly = "SuccessModal-module--mobileOnly--8ad8b";
export var modalBody = "SuccessModal-module--modalBody--3a145";
export var modalContainer = "SuccessModal-module--modalContainer--23ef8";
export var modalHeader = "SuccessModal-module--modalHeader--803c1";
export var textLeft = "SuccessModal-module--textLeft--72b78";
export var visuallyHidden = "SuccessModal-module--visuallyHidden--c7f0c";